// ui library
import { color } from '@upstox/upstox-ui';
import { fonts } from '@upstox/upstox-ui/theme/light/fonts';

export const notificationContainer: CSSFunction = ({ theme }) => ({
  padding: '8px 16px',
  backgroundColor: color(theme, theme.colors.background.tan2),
  fontFamily: fonts.tvFont,
});

export const notificationText: CSSFunction = () => ({
  fontSize: '12px',
  lineHeight: '16px',
});

export const boldText: CSSFunction = ({ theme }) => ({
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 700,
  color: color(theme, theme.colors.text[1]),
  whiteSpace: 'break-spaces',
});

export const normalText: CSSFunction = ({ theme }) => ({
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
  color: color(theme, theme.colors.text[1]),
  whiteSpace: 'break-spaces',
});

export const actionButton: CSSFunction = ({ theme }) => ({
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 700,
  color: color(theme, theme.colors.text.link),
  cursor: 'pointer',
  textDecoration: 'underline',
});

export const notificationTextContainer: CSSFunction<{
  mobileScreen: boolean;
}> = ({ cssProps }) => {
  const { mobileScreen } = cssProps;
  return {
    display: 'flex',
    flexDirection: mobileScreen ? 'column' : 'row',
    flex: 1,
    marginLeft: 8,
    alignItems: 'flex-start',
  };
};
